const styles = theme => ({
  root: {
    width: '100%'
  },
  table: {
    width: '100%'
  },
  tableBody: {

  },
  tableRow: {

  },
  tableCell: {
  },
  faultsTable: {

  },
  faultsTableBody: {

  },
  faultsTableRow:{
    height: 'auto'
  },
  faultsTableCell:{
    borderBottom: 'none'
  }
})

export default styles
